
<div>
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
      <div class="row">
        <!--<div class="col-md-1 padding-left-0px padding-right-0px">
        <a class="education-navlink addicon-circle">
          <span class="badge">

            <i class="fas fa-user-plus"></i>
          </span>
        </a>
      </div>-->
        <div class="col-md-4 padding-left-9px padding-right-0px">
          <label class="margin-top-3px">Profile</label>
        </div>
        <div class="col-md-6 padding-left-0px">
          <label class="margin-top-3px">Update Status</label>
        </div>
        <div class="col-md-2">
          <button type="button" class="close float-right margin-top-4px" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!--<div class="col-md-8 float-right" *ngIf="CurrentCounsellingPlanController.length==0">
        <div class="row">
          <div class="col-md-8">
            <label class="margin-top-3px"> Add Proposed Plan</label>
          </div>
          <div class="col-md-4">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>

      </div>
      <div class="col-md-8 float-right" *ngIf="CurrentCounsellingPlanController.length>0">
        <div class="row">
          <div class="col-md-8">
            <label class="margin-top-3px"> Counselling Plan (Active)</label>
          </div>
          <div class="col-md-4">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>

      </div>-->
      </div>



    </div>
    <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
      <div class="modal-body padding-top-0px counselling-modal">

        <div class="row" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
          <div class="col-md-4 padding-left-0px">
            <div class=" card bk-color-light2 card-height">
              <div class="row margin-top-10">
                <div class="offset-md-3 col-md-3 padding-left-0px">
                  <img class="img-circle-50 margin-left-10px" [src]="l.PatientImageFile" onError="this.src='dummy.jpg';">
                  <!--<img  class="img-circle-50 margin-left-10px" *ngIf="!l.PatientImageFile" src="dummy.jpg">-->
                </div>
              </div>
              <div class="row">
                <div class="offset-md-2 col-md-8 padding-left-0px padding-right-0px text-align-center">
                  <label class="margin-bottom-0px color5 font-weight-bold font-size-19px margin-bottom-0px">{{l.DisplayName}}</label>
                </div>
              </div>
              <div class="row">
                <div class="offset-md-3 col-md-7">
                  <label class="margin-bottom-0px">{{l.FormattedCode}}</label>
                </div>
              </div>
              <div class="row">
                <div class="offset-md-3 col-md-8">
                  <label class="margin-bottom-0px">
                    <!--32yrs,Female-->
                    {{l.Age}},{{l.Gender}}
                  </label>
                </div>
              </div>
              <div class="row">
                <!--<div class="col-md-3">
                <label>Phone Number:</label>
              </div>-->
                <div class="offset-md-3 col-md-6">
                  {{l.Telephone1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8 padding-right-0px">




            <div class="col-md-12">
              <div class="row margin-top-10 ">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-top-5px">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Close Cycle</label>
                    </div>


                    <div class="col-md-5">

                      <!--<input type="checkbox" class="width-18px background-2" [(ngModel)]="CurrentUpdateIvfCycleByActivityRequest.IsCycleClosed" name="CurrentUpdateIvfCycleByActivityRequest.IsCycleClosed">-->
                      <input type="checkbox" class="width-18px background-2" >
                    </div>
                  </div>


                </div>
              </div>



              <div class="row ">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                    </div>

                    <div class="col-md-6 padding-right-0px">
                      <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                name="CurrentUpdateIvfCycleByActivityRequest.ClosingRemarks"
                                [(ngModel)]="CurrentUpdateIvfCycleByActivityRequest.ClosingRemarks" required minlength="1" maxlength="100"
                                #addconcerns_text="ngModel"></textarea>
                      <small class="form-text text-danger"
                             *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                    </div>
                  </div>


                </div>
              </div>
              <!--<div class="row float-right">
              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px" (click)="activeModal.close('Close click')">Cancel</button>
              <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting && isvisible'  class="btn font-size-13px actions-btn-prime">Save</button>
            </div>-->
            </div>

    

  </div>
          </div>



        </div>
      <div class="modal-footer padding-top-10px padding-bottom-10px">

        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px" (click)="activeModal.close('Close click')">Cancel</button>
        <button type="submit"  class="btn font-size-13px actions-btn-prime">Save</button>
      </div>
   </form>
  </div>
</div>
